<template>
  <div>
    <!--账户余额-->
    <div class="recharge_box">
      <span>{{ $t('key1005886') }}</span>
      <span class="balance">{{ balance }}</span>
      <Button class="btn ml10" type="primary" ghost v-if="getPermission('ymsDistributorMerchantRechargeRecord_alipay')
      && onlineBalanceRecharge" @click="$refs['recharge'].initRechargeData()">{{ $t('key1003742') }}</Button>
      <span class="ml50">{{ $t('key1005887') }}</span>
      <span class="balance">{{ distributorWithholdingAmount }}</span>
      <Tooltip max-width="500" placement="top" transfer :content="$t('key1005882')">
        <Icon class="cursor ml5" color="#FD5425" size="20" type="md-alert"/>
      </Tooltip>
      <template v-if="isSettingQuota">
        <span class="ml50">{{ $t('key1005888') }}</span>
        <span class="balance">{{ distributorInitialQuota }}</span>
        <Button class="btn ml10" type="primary" @click="$refs['commonLog'].initCommonLogData(ymsDistributorMerchantId)">{{ $t('key1005889') }}</Button>
        <span class="ml50">{{ $t('key1005890') }}</span>
        <span class="balance">{{ distributorUsedQuota }}</span>
        <Tooltip max-width="500" placement="top" transfer
          :content="$t('key1005883')">
          <Icon class="cursor ml5" color="#FD5425" size="20" type="md-alert"/>
        </Tooltip>
      </template>
    </div>
    <div class="distributor-box">
      <!--头部筛选区域-->
      <div class="filter-box">
        <Form ref="pageParams" :model="pageParams" :label-width="100" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1003737')" class="date_picker_style">
                <Date-picker
                  type="datetimerange"
                  @on-clear="resetDate"
                  @on-change="getDateValue"
                  :options="dateOptions"
                  :clearable="true"
                  format="yyyy-MM-dd HH:mm:ss"
                  placement="bottom-end"
                  :placeholder="$t('key1000360')"
                  :value="rechargeTime">
                </Date-picker>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1003739')" prop="ymsDistributorMerchantRechargeRecordIds">
                <Input type="textarea" :placeholder="$t('key1003740')"
                  v-model.trim="pageParams.ymsDistributorMerchantRechargeRecordIds"></Input>
              </Form-item>
            </Col>
            <Col style="min-width: 170px;" push="1">
              <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
              <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
            </Col>
          </Row>
        </Form>
      </div>
      <!--功能按钮操作区域-->
      <div class="operation-box">
        <Dropdown transfer @on-click="changeExportBtn"
          v-if="getPermission('ymsDistributorMerchantRechargeRecord_exportRechargeRecord')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <!--列表区域-->
      <div class="table-box">
        <Table
          ref="selection"
          highlight-row
          border
          max-height="550"
          :loading="tableLoading"
          :columns="tableColumns"
          @on-selection-change="tableChange"
          :data="tableData">
        </Table>
      </div>
      <!--分页区域-->
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        class="distributor-page-box"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--余额充值弹窗-->
    <rechargeModal ref="recharge" @updateData="updateData"></rechargeModal>
    <!--充值福利说明弹窗-->
    <Modal v-model="activityDescriptionModal" :title="$t('key1005884')" width="682">
      <img :src="rechargeBenefitsImg" width="650" height="400" alt="">
      <template #footer>
        <Button type="primary" @click="activityDescriptionModal = false">{{ $t('key1000732') }}</Button>
      </template>
    </Modal>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003741')"
      paramKeyColums="ymsMerchantRechargeRecordExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="DISTRIBUTOR" :logType="['SYSTEM_LOG']" :title="$t('key1005885')"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import rechargeModal from "@/views/distributor/components/assetManage/rechargeModal.vue";
import api from '@/api/';
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {
  downloadTemplateFile, isImageFile, isAlibabaDistributor, pageJump,
  setConfigCharacters, commonLocalStorage, getCurrencyData, getAllUsersInfo,
  getDataSetBatchList, getEnumName, getDistributorBalanceInfo, calculateDistributorAmount
} from "@/utils/common";
import commonLogModal from "@/components/common/commonLogModal.vue";

export default {
  name: "rechargeRecord",
  mixins: [Mixin],
  components: {
    commonLogModal,
    rechargeModal,
    exportFieldsModal
  },
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        startRechargeTime: null,
        endRechargeTime: null,
        ymsDistributorMerchantRechargeRecordIds: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      balance: 0,
      distributorUsedQuota: 0, // 已使用额度
      distributorInitialQuota: 0, // 总计信用额度
      distributorWithholdingAmount: 0, // 预扣金额
      ymsDistributorMerchantId: null,
      rechargeTime: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left',
          fixed: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003724'),
          key: 'ymsDistributorMerchantRechargeRecordId',
          minWidth: 200,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003725'),
          key: 'paymentSerialNumber',
          minWidth: 170,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003726'),
          align: 'left',
          minWidth: 260,
          key: 'paymentPicturePath',
          render(h, params) {
            let imgList = [];
            let fileList = [];
            let paymentPicturePathList = params.row.ymsDistributorMerchantRechargeRecordImages || [];
            if (paymentPicturePathList.length > 0) {
              paymentPicturePathList.map((item) => {
                if (isImageFile(item.paymentPicturePath)) {
                  imgList.push(h('div', {class: 'm5'}, [v.tableImg(h, params,
                    null, item.paymentPicturePath, null, 'left', false, false)]))
                } else {
                  fileList.push(h('p', {
                    class: 'cursor mt2 mb2 themeColor',
                    style: {
                      textAlign: 'left'
                    },
                    on: {
                      click() {
                        if (item.paymentPicturePath) {
                          downloadTemplateFile(item.paymentPicturePath);
                        }
                      }
                    },
                  }, item.name))
                }
              });
              return h('div', [
                h('div', {class: 'flex flex-wrap'}, [imgList]),
                fileList
              ]);
            }
          },
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000289'),
          minWidth: 100,
          key: 'operationType',
          align: 'left',
          render(h, params) {
            let operationType = params.row.operationType;
            let text = getEnumName(v.enumData, 'YmsDistributorMerchantRechargeRecordOperationTypeCoreEnum', operationType);
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003727'),
          key: 'rechargeAmount',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', [
              h('p', v.formatCurrency(params.row.rechargeAmount)),
              h('p', '(' + params.row.currency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003728'),
          key: 'balance',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', [
              h('p', v.formatCurrency(params.row.balance)),
              h('p', '(' + params.row.balanceCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003729'),
          key: 'balanceAfterRecharge',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            let amountAfterRechargeStr = params.row.amountAfterRechargeStr || 0;
            let num = v.formatCurrency(amountAfterRechargeStr) === '-0.00' ? '0.00' : v.formatCurrency(amountAfterRechargeStr);
            return h('div', [
              h('p', num),
              h('p', '(' + params.row.balanceCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003187'),
          key: 'withholdingAmount',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', [
              h('p', v.formatCurrency(params.row.withholdingAmount)),
              h('p', '(' + params.row.withholdingAmountCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005875'),
          key: 'initialQuota',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', [
              h('p', v.formatCurrency(params.row.initialQuota)),
              h('p', '(' + params.row.initialQuotaCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005876'),
          key: 'afterRemainQuota',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', [
              h('p', v.formatCurrency(params.row.afterRemainQuota)),
              h('p', '(' + params.row.remainQuotaCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          align: 'left',
          sortable: true,
          minWidth: 170,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remarks',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remarks, 150, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626'),
          key: 'paymentMethod',
          minWidth: 110,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003732'),
          key: 'status',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            const statusText = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003722'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003723')];
            return h('span', statusText[params.row.status]);
          }
        },
        {
          key: 'updatedBy',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          minWidth: 120,
          align: 'left',
          render: (h, params) => {
            let userName = '';
            if (v.userInfoList !== null && v.userInfoList[params.row.updatedBy] !== undefined) {
              userName = v.userInfoList[params.row.updatedBy].userName;
            } else if (params.row.updatedBy === aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000349')) {
              userName = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319')}`;
            } else {
              userName = '';
            }
            return h('div', userName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          fixed: 'right',
          width: 120,
          align: 'left',
          render(h, params) {
            // 充值失败 充值中
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005877'),
                    show: (params.row.status === 3 || params.row.status === 1) && v.onlineBalanceRecharge
                      && v.getPermission('ymsDistributorMerchantRechargeRecord_alipay'),
                    clickFn: () => {
                      if (params.row.paymentMethod === aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692')) {
                        v.$refs['recharge'].alipayPayment({
                          remarks: "",
                          subject: "",
                          totalAmount: params.row.rechargeAmount,
                          ymsDistributorMerchantRechargeRecordId: params.row.ymsDistributorMerchantRechargeRecordId
                        });
                      }
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      rechargeBenefitsBannerImg: require('@/assets/images/recharge_banner.jpg'),
      rechargeBenefitsImg: require('@/assets/images/recharge_benefits.jpg'),
      activityDescriptionModal: false,
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'ymsDistributorMerchantRechargeRecordId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003724')},
            {paramKey: 'paymentSerialNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003725')},
            {paramKey: 'rechargeAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003727')},
            {paramKey: 'balance', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003728')},
            {paramKey: 'amountAfterRechargeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003729')},
            {paramKey: 'withholdingAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003187')},
            {paramKey: 'initialQuota', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005875')},
            {paramKey: 'remainQuota', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005876')},
            {paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291')},
            {paramKey: 'remarks', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
            {paramKey: 'paymentMethod', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626')},
            {paramKey: 'operationType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000289')},
          ]
        }
      ],
      isSettingQuota: 0,
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    onlineBalanceRecharge() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.onlineBalanceRecharge.length > 0 || false;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  created() {
    let v = this;
    v.setDefaultTimerParams('three_months');
    v.initFun();
    if (localStorage.getItem('openRechargeTalg')) {
      let talg = JSON.parse(localStorage.getItem('openRechargeTalg'));
      if (talg) {
        v.$nextTick(() => {
          v.$refs['recharge'].initRechargeData();
          localStorage.removeItem('openRechargeTalg');
        });
      }
    }
  },
  beforeDestroy() {
    this._isDestroyed = true;
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = ['YmsDistributorMerchantRechargeRecordOperationTypeCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getCurrencyData();
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.search();
        await v.getAmount();
        await v.initWebSocket();
      })();
    },
    /**
     * 注册充值支付结果使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `recharge-record-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data && data.type === 'pay' && !isAlibabaDistributor()) {
          const statusText = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005878'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005879'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005880')];
          if (data.data.status === 2) {
            v.$Message.success(statusText[2] + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005881') + data.data.paymentSerialNumber);
          } else if (data.data.status === 3) {
            v.$Message.error(statusText[3] + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005881') + data.data.paymentSerialNumber);
          } else {
            v.$Message.success(statusText[data.data.status]);
          }
          v.getAmount();
          v.search();
        }
      }, v);
    },

    /**
     * 清理充值支付结果监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 更新列表数据
    updateData() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.rechargeTime = [];
      v.resetDate();
      v.$refs['pageParams'].resetFields();
      v.selectTableData = [];
      v.setDefaultTimerParams('three_months');
      v.getList();
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.startRechargeTime = null;
          v.pageParams.endRechargeTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.rechargeTime = v.defaultTimePeriod(value, false);
          v.pageParams.startRechargeTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.endRechargeTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    async getAmount() {
      let amountData = await getDistributorBalanceInfo(this.userInfo.merchantId);
      if (amountData) {
        let obj = calculateDistributorAmount(amountData);
        const currencyPrefix = (obj.currency || this.currencyState) + ' ';
        this.ymsDistributorMerchantId = obj.ymsDistributorMerchantId;
        // 是否设置额度
        this.isSettingQuota = obj.isSettingQuota;
        // 当前可用余额
        this.balance = currencyPrefix + obj.balance;
        // 已使用额度
        this.distributorUsedQuota = currencyPrefix + obj.distributorUsedQuota;
        // 初始总额度
        this.distributorInitialQuota = obj.distributorInitialQuota;
        // 预扣金额
        this.distributorWithholdingAmount = obj.distributorWithholdingAmount;
      } else {
        this.balance = 0;
        this.distributorInitialQuota = 0;
        this.distributorUsedQuota = 0;
        this.distributorWithholdingAmount = 0;
      }
    },
    // 重置时间
    resetDate() {
      this.pageParams.startRechargeTime = null;
      this.pageParams.endRechargeTime = null;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (['ymsDistributorMerchantRechargeRecordIds'].includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      if (v.getPermission('ymsDistributorMerchantRechargeRecord_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorMerchantRechargeRecord_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsDistributorMerchantRechargeRecordId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsDistributorMerchantRechargeRecordIds = v.selectTableData;
      } else {
        if (v.pageParams.ymsDistributorMerchantRechargeRecordIds) {
          query.ymsDistributorMerchantRechargeRecordIds = v.sepCommasFn(v.pageParams.ymsDistributorMerchantRechargeRecordIds, ['\n']);
        } else {
          query.ymsDistributorMerchantRechargeRecordIds = [];
        }
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsDistributorMerchantRechargeRecord_exportRechargeRecord, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.balance {
  padding: 0 5px;
  font-weight: bold;
  color: #FC5426;
}

.recharge_box {
  padding: 15px 0 15px 30px;
  background-color: #ffffff;
  font-size: 16px;
  margin-bottom: 10px;
  position: relative;
  height: 62px;

  .b-icon {
    color: #FD5425;
    margin-right: 5px;
  }

  .btn {
    line-height: 16px;
  }
}

</style>
